import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {ITanneryDyeingSchedule} from "../../../../../../utils/interfaces/tannery_dyeing/ITanneryDyeingSchedule";


const useApiGetTanneryDyeingScheduleHistorical = (
    companyToken: string | undefined,
    data_inizio_storico?: string,
): UseQueryResult<ITanneryDyeingSchedule[], CustomAxiosError> => {

    const {get} = useApiCalls();

    async function doGet(company_token: string | undefined, data_inizio_storico?: string): Promise<ITanneryDyeingSchedule[]> {
        try {
            const params = data_inizio_storico ? {data_inizio_storico} : undefined;
            const response = await get(`/api/company/${company_token}/tannery_dyeing/historical`, params);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }


    return useQuery({
        queryKey: ['getTanneryDyeingScheduleHistorical', data_inizio_storico],
        queryFn: () => doGet(companyToken, data_inizio_storico)
    })
};

export default useApiGetTanneryDyeingScheduleHistorical